import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { statusDefaultTextValue } from '@shared/constants';
import { AdditionalFilters, TextValue } from '@shared/interfaces';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { FocusTrapModule } from 'primeng/focustrap';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
    selector: 'app-status-filters-single-select',
    standalone: true,
    imports: [
        SelectButtonModule,
        TranslateModule,
        ButtonModule,
        OverlayPanelModule,
        FocusTrapModule,
        DividerModule,
        CheckboxModule,
        FormsModule,
        NgClass,
    ],
    templateUrl: './status-filters-single-select.component.html',
    styleUrl: './status-filters-single-select.component.scss',
})
export class StatusFiltersSingleSelectComponent implements OnChanges {
    @Input({ required: true }) statusesToDisplay: TextValue[] = [];
    @Input({ required: true }) selectedStatus!: number[] | number;
    @Input() id: string = 'status-filters';
    @Input() additionalFilters: AdditionalFilters[] = [];
    @Output() statusChanged: EventEmitter<number[] | number> = new EventEmitter<number[] | number>();
    @Output() additionalFilterValueChange: EventEmitter<AdditionalFilters> = new EventEmitter<AdditionalFilters>();

    selectedStatusTextValue: TextValue = statusDefaultTextValue;
    includeAdditionalFilterValue: boolean = false;

    onStatusSelect(option: number) {
        this.selectedStatusTextValue =
            this.statusesToDisplay.find(status => status.value === option) ?? this.statusesToDisplay[0];
        this.statusChanged.emit(option);
    }

    ngOnChanges(): void {
        this.selectedStatusTextValue =
            this.statusesToDisplay.find(status => status.value === (this.selectedStatus as number)) ??
            this.statusesToDisplay[0];
    }
}
